import styled from 'styled-components';

export const StyledBody = styled.span`
  color: ${({ theme }) => theme.colors.addButton.textHover};
`;
